export const BOUNDARY_FORM_RESET = 'BOUNDARY_FORM_RESET';
export const BOUNDARY_FORM_SET_TYPE_AND_MODE = 'BOUNDARY_FORM_SET_TYPE_AND_MODE';
